/** Route of the mandatory consent gate (Terms + Privacy Policy, see pages/Consent/RequiredConsent). */
export const CONSENT_ROUTE = '/consent';

/** Route of the Privacy Center (data export and account deletion request). */
export const PRIVACY_CENTER_ROUTE = '/privacy';

/**
 * Protected paths still reachable while required consents are pending: the consent gate itself,
 * the forced password change, which comes first (the backend rejects every other request,
 * including accepting consents, until the password has been changed), and the Privacy Center, so a
 * user who refuses the Terms can still exercise the GDPR rights of export and deletion (the
 * backend allowlists exactly those endpoints, see RequiredConsentFilter).
 */
const CONSENT_GATE_EXEMPT_PATHS = [CONSENT_ROUTE, '/change-password', PRIVACY_CENTER_ROUTE];

export const isConsentGateExempt = (pathname: string): boolean =>
  CONSENT_GATE_EXEMPT_PATHS.includes(pathname);

/**
 * Where each required document can be read: the Terms page and the standalone Privacy Policy page
 * (both public, so they can be opened before signing in).
 */
export const CONSENT_DOCUMENT_LINKS = {
  TERMS: '/terms',
  PRIVACY: '/privacy-policy',
} as const;

/** Link to read a required document, by consent type (undefined for unknown types). */
export const consentDocumentLink = (consentType: string): string | undefined =>
  (CONSENT_DOCUMENT_LINKS as Record<string, string | undefined>)[consentType];
